<app-menu [collapsed]="collapsed" />

<div class="bottom">
    <button (click)="toggle()">
        <span class="material-symbols-rounded" *ngIf="!collapsed" aria-label="Collapse menu">
            keyboard_double_arrow_left
        </span>
        <span *ngIf="!collapsed">{{ 'GENERAL.MINIMIZE' | translate }}</span>
        <span class="material-symbols-rounded" *ngIf="collapsed" aria-label="Collapse menu">
            keyboard_double_arrow_right
        </span>
    </button>
</div>
